import React from 'react';
import { Upload } from 'lucide-react';

interface MediaUploadProps {
  isDragging: boolean;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onFileSelect: (files: FileList) => void;
  uploadProgress: { [key: string]: number };
}

export function MediaUpload({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect,
  uploadProgress
}: MediaUploadProps) {
  return (
    <>
      <div
        className={`border-2 border-dashed rounded-lg p-6 ${
          isDragging ? 'border-indigo-500 bg-indigo-50' : 'border-gray-300'
        }`}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className="text-center">
          <Upload className="mx-auto h-12 w-12 text-gray-400" />
          <div className="mt-2">
            <label className="cursor-pointer">
              <span className="text-indigo-600 hover:text-indigo-500">Upload files</span>
              <span className="text-gray-500"> or drag and drop</span>
              <input
                type="file"
                className="hidden"
                accept="image/*,video/*"
                multiple
                onChange={(e) => e.target.files && onFileSelect(e.target.files)}
              />
            </label>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            Images (PNG, JPG) or Videos (MP4)
          </p>
        </div>
      </div>

      {Object.entries(uploadProgress).map(([fileName, progress]) => (
        <div key={fileName} className="mt-2">
          <div className="text-sm text-gray-600">{fileName}</div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-indigo-600 h-2.5 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      ))}
    </>
  );
}